"use client";

import React, { useRef, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const YouTubePlaylistScroller = ({ videoIds }) => {
  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const scroll = (direction) => {
    if (!scrollRef.current) return;

    const width = scrollRef.current.clientWidth;
    const scrollAmount = width * 0.9;

    scrollRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const handleScroll = () => {
    if (!scrollRef.current) return;

    const container = scrollRef.current;
    const itemWidth = container.clientWidth;
    const index = Math.round(container.scrollLeft / itemWidth);

    setCurrentIndex(index);
  };

  return (
    <>
      <section className="w-full bg-gradient-radial py-12 lg:py-15 !pb-3 relative overflow-hidden">
        <div className="container mx-auto px-4 lg:px-15 text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold font-urbanist text-white text-center sm:text-center py-5">
            See What Professionals Say About Us?
          </h2>
          <div className="relative w-full ">
            {/* Slider Container */}
            <div
              ref={scrollRef}
              onScroll={handleScroll}
              className="yt-scrollbar flex gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory px-4 py-4 "
            >
              {videoIds.map((id, index) => (
                <div
                  key={index}
                  className="
              min-w-full sm:min-w-[48%] lg:min-w-[22%]
              snap-center
              bg-white/10 backdrop-blur-xl border border-white/20 shadow-xl
              rounded-2xl overflow-hidden
              transition-all hover:scale-[1.03]
            "
                >
                  <iframe
                    className="w-full h-[400px]"
                    src={`https://www.youtube-nocookie.com/embed/${id}?rel=0`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              ))}
            </div>

            {/* Desktop Arrows */}
            <button
              onClick={() => scroll("left")}
              className="
          hidden lg:flex
          absolute top-1/2 -translate-y-1/2
          bg-white/20 backdrop-blur-xl border border-white/30
          p-3 rounded-full text-white shadow-xl hover:bg-white/40
          transition
        "
              style={{ left: "-20px" }}
            >
              <FiChevronLeft size={28} />
            </button>

            <button
              onClick={() => scroll("right")}
              className="
          hidden lg:flex
          absolute top-1/2 -translate-y-1/2
          bg-white/20 backdrop-blur-xl border border-white/30
          p-3 rounded-full text-white shadow-xl hover:bg-white/40
          transition
        "
              style={{ right: "-20px" }}
            >
              <FiChevronRight size={28} />
            </button>

            {/* Mobile Dots */}
            <div className="flex lg:hidden justify-center mt-3 gap-2 ">
              {videoIds.map((_, i) => (
                <div
                  key={i}
                  className={`h-2 w-2 rounded-full transition-all ${
                    currentIndex === i ? "bg-white w-4" : "bg-white/40"
                  }`}
                />
              ))}
            </div>

            {/* Scoped CSS — hides scrollbar only for this component */}
            <style jsx>{`
              .yt-scrollbar::-webkit-scrollbar {
                display: none;
              }
              .yt-scrollbar {
                -ms-overflow-style: none;
                scrollbar-width: none;
              }
            `}</style>
          </div>
        </div>
      </section>
    </>
  );
};

export default YouTubePlaylistScroller;
